import React from 'react'

import { BLOCKS } from '@contentful/rich-text-types'

import { convertToSlug } from 'helpers/resources'

import ContentFootnote from './components/ContentFootnote'
import ContentGearTip from './components/ContentGearTip'
import ContentImage from './components/ContentImage'
import ContentInlineFrame from './components/ContentInlineFrame'
import ContentProduct from './components/ContentProduct'
import ContentPullQuote from './components/ContentPullQuote'
import ContentReadOn from './components/ContentReadOn'
import ContentTable from './components/ContentTable'
import EmbedVideo from './components/EmbedVideo'
import Heading from './components/Heading'
import InlineFaas from './components/InlineFaas'

const getCustomNodes = () => ({
  [BLOCKS.HEADING_2]: ({ content }) => {
    const { value } = content[0]
    const id = convertToSlug(value)
    return <Heading id={id}>{value}</Heading>
  },
})

const customEmbeddeds = {
  ContentInfographicImage: ContentImage,
  ContentWideImage: ContentImage,
  ContentNarrowImage: props => <ContentImage {...props} isNarrow />,
  ContentFootnote,
  ContentGearTip,
  ContentReadOn,
  ContentPullQuote,
  IframeContainer: ContentInlineFrame,
  ContentTable,
  ContentProduct,
  EmbedVideo: props => <EmbedVideo video={props} />,
  InlineFaas: props => (
    <InlineFaas formId={props?.formId} minHeight={props?.minHeight} pageCategory={props?.pageCategory?.slug} />
  ),
}

export default {
  getCustomNodes,
  customEmbeddeds,
}
